import { render, staticRenderFns } from "./SocialItem.vue?vue&type=template&id=0c9f33b2"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9f33b2')) {
      api.createRecord('0c9f33b2', component.options)
    } else {
      api.reload('0c9f33b2', component.options)
    }
    module.hot.accept("./SocialItem.vue?vue&type=template&id=0c9f33b2", function () {
      api.rerender('0c9f33b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/SocialItem.vue"
export default component.exports